import styled from 'styled-components';
import { Typography } from '@mui/material';

import AutoComplete from '../../../../components/AutoComplete';
import colors from '../../../../../styles/colors';

const StyledAutoComplete = styled(AutoComplete)`
  .MuiAutocomplete-inputRoot {
    width: 600px;
  }

  .MuiAutocomplete-listbox {
    align-items: flex-start;
  }

  .MuiAutocomplete-option {
    align-items: flex-start;
  }
`;

const StyledContractOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &.MuiAutocomplete-option {
    align-items: flex-start;
  }
`;

const StyledHelperText = styled(Typography)`
  font-size: 12px;
  margin-left: 15px;
  line-height: 16px;
  color: ${colors.shades.gamma14};
  margin-top: 4px;
`;

export { StyledAutoComplete, StyledContractOption, StyledHelperText };
